import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import {IPlanDetailsLife, IPlanInformationLife} from 'Pages/Customer360/types'
import { bobMasterUrlQuery} from 'Services/baseQuery'

export const masterCustomer360Api = createApi({
  reducerPath: 'master360',
  baseQuery: bobMasterUrlQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getLifePolicyInformation: builder.query<IPlanInformationLife, IPlanDetailsLife>({
      query: (filters) => ({
        url: `${API_ENDPOINTS.BOB.GET_LIFE_POLICY_INFORMATION}`,
        method: 'GET',
        params: filters,
        rawResponse: true,
      }),
    }),
  }),
})

export const { useLazyGetLifePolicyInformationQuery } = masterCustomer360Api


